<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row" style="justify-content: space-between;border-bottom: none;">
                                <div class="col">
                                    <div class="d-flex flex-start">
                                        <div class="flex-item mr-2" v-if="page != 'selectMethod'" style="cursor: pointer;" @click="page = 'selectMethod'"><i class="fa fa-arrow-left"></i></div>
                                        <div class="flex-item"><h5>{{ title }}</h5></div>
                                    </div>
                                </div>
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <hr class="mt-0">

                            <div class="modal-body text-center p-10">
                                
                                <div v-if="page == 'selectMethod'" class="mb-3">
                                    <b-container>
                                        <b-row class="justify-content-center">
                                        <b-col cols="12" md="5" class="p-10" @click="page = 'satuan'">
                                            <div class="boxHover border border-grey rounded text-center d-flex flex-column align-items-center justify-content-center pl-4 pr-4" style="height:350px">
                                                <img src="@/assets/img/icon/pengiriman-satuan.png" style="width:auto;height: 5em;" class="mb-4"/>
                                                <h3>Pengiriman Satuan</h3>
                                                <p>Buat pengiriman untuk satu destinasi dealer</p>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" md="5" class="p-10" @click="page = 'file'">
                                            <div class="boxHover border border-grey rounded text-center d-flex flex-column align-items-center justify-content-center pl-4 pr-4" style="height:350px">
                                                <img src="@/assets/img/icon/pengiriman-gabungan.png" style="width:auto;height: 5em;" class="mb-4"/>
                                            <h3>Pengiriman Gabungan</h3>
                                            <p>Buat pengiriman untuk berbagai destinasi dealer</p>
                                            </div>
                                        </b-col>
                                        </b-row>
                                    </b-container>
                                </div>

                                <div v-else-if="page == 'satuan'" class="mb-3">
                                    <div class="row">
                                        <div class="col-3 mt-auto mb-auto">
                                            <h6>Dealer Tujuan</h6>
                                        </div>
                                        <div class="col-7">
                                            <input type="text" class="form-control" v-model="satuan.dealer"/>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-3 mt-auto mb-auto">
                                            <h6 class="mb-0">Jumlah QR</h6>
                                            <span style="font-size: 9px;">Jumlah Kelipatan 50</span>
                                        </div>
                                        <div class="col-7">
                                            <input type="text" class="form-control" v-model="satuan.dealer"/>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-3 mt-auto mb-auto">
                                            <h6>Dealer Tujuan</h6>
                                        </div>
                                        <div class="col-7">
                                            <input type="text" class="form-control" v-model="satuan.dealer"/>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end mt-4" >
                                        <div class="flex-item" style="width: 100px">
                                            <button class="mpm-button-outline btn w-100 " @click="$emit('closeModal')">Batal</button>
                                        </div>
                                        <div class="flex-item ml-3 mr-3" style="width: 100px">
                                            <button class="mpm-button btn w-100" >Buat</button>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div v-else class="mb-3">

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import qs from 'qs';

    export default {
        data() {
            return {
                page : 'selectMethod',
                title : 'Metode Pengiriman',
                masterPage : [{
                    page : 'selectMethod',
                    title : 'Metode Pengiriman'
                },{
                    page : 'file',
                    title : 'Pengiriman Gabungan'
                },{
                    page : 'satuan',
                    title : 'Pengiriman Satuan'
                }],
                satuan : {
                    dealer : '',
                    qty : 0,
                    bast : ''
                }
            }
        },
        watch : {
            page : function () {
                this.title = this.masterPage.find(x => this.page == x.page).title

                this.satuan.dealer = ''
                this.satuan.qty = 0
                this.satuan.bast = ''
            }
        },
        mounted() {
            
        },
        methods: {

        }
    }
</script>
<style>
    .b-card {
        border: none; /* Removes border */
        box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* Adds shadow for depth */
        padding: 20px; /* Adds some padding inside the card */
        margin: 20px 0; /* Adds vertical spacing */
    }

    b-icon {
        margin-bottom: 20px; /* Space between icon and text */
    }
</style>
<style scoped>
    .boxHover:hover {
        background-color: rgb(85, 85, 85);
        color:white;
        cursor: pointer;
    }

    .border-grey {
        border-color: #e3e2e2 !important;
    }
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        /* padding: 20px 30px; */
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        padding: 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }
</style>